import { UserBrief } from '../user-brief.model';

// Interfaces
export interface BaseTableColumns {
    id: number;
    sender: string;
    service: string;
    client: string;
    date: string;
}

export interface InProgressTableColumns extends BaseTableColumns {
    assignee: UserBrief;
}
export interface CompletedoperationTableColumns extends BaseTableColumns {
    operationclosedDate: string;
}
export interface DashboardTableColumns extends InProgressTableColumns {
    status: number;
}

// Classes
export class BaseTableColumns implements BaseTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string
    ) {}
}

export class NewRequestTableColumns extends BaseTableColumns {}

export class ReturnedRequestTableColumns extends BaseTableColumns {}

export class AssignedToMeRequestTableColumns extends BaseTableColumns {}

export class CompletedMeRequestTableColumns implements InProgressTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string,
        public assignee: UserBrief,
        public closedDate?: string
    ) {}
}
export class CompletedMeRequestOperationTableColumns implements CompletedoperationTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string,
        public assignee: UserBrief,
        public operationclosedDate: string
    ) {}
}
export class InProgressRequestTableColumns implements InProgressTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string,
        public assignee: UserBrief
    ) {}
}

export class SecurityCordinatorRequestTableColumns {
    constructor(
        public id: number,
        public date: string,
        public sender: string,
        public service: string,
        public requester: string,
        public client: string,
        public statustxt: string
    ) {}
}

export class TechnicalOperationsRequestsTableColumns {
    constructor(
        public id: number,
        public date: string,
        public sender: string,
        public service: string,
        public client: string,
        public statustxt: string,
        public closedDate?: string
    ) {}
}

export class DashboardTableColumns implements DashboardTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string,
        public assignee: UserBrief,
        public status: number,
        public statustxt: string
    ) {}
}

export class DashboardTableColumnsForSuperAdmin implements DashboardTableColumns {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public client: string,
        public date: string,
        public assignee: UserBrief,
        public status: number,
        public statustxt: string
    ) {}
}

export class DashboardTableColumnsForAccountManager {
    constructor(
        public id: number,
        public sender: string,
        public service: string,
        public date: string,
        public status: number,
        public statustxt: string
    ) {}
}

export type AdminTableColumns =
    | NewRequestTableColumns
    | ReturnedRequestTableColumns
    | AssignedToMeRequestTableColumns
    | InProgressRequestTableColumns
    | CompletedMeRequestTableColumns
    | DashboardTableColumns
    | SecurityCordinatorRequestTableColumns;
